import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import checkIcon from 'src/assets/svg/1-foundations-icons-24-check.svg';
import descriptionIcon from 'src/assets/svg/1-foundations-icons-24-description.svg';

const { fonts, spacing, text } = theme;

export const wrapper = (isTheLastItem = false) => css`
  margin: ${stack(spacing.xl)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: ${isTheLastItem ? stack(spacing.xxl) : stack(spacing.xxxxl)};
    `,
  )}
`;

export const overlay = css`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  opacity: 0.75;
  background-color: var(--neutral-black-base);
  pointer-events: none;
`;

export const contentSection = (hasMembershipAdded: boolean, isNothsAndMoreMember: boolean) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: ${pxToRem(spacing.xl)};
  padding-right: ${pxToRem(spacing.xl)};

  a {
    margin-bottom: ${pxToRem(spacing.xl)};
  }

  ${(hasMembershipAdded || isNothsAndMoreMember) &&
  css`
    a {
      padding-left: ${pxToRem(spacing.xxl)};
      background-image: url(${checkIcon});
      background-position: 0 50%;
      background-repeat: no-repeat;
      text-decoration: none;
      cursor: none;
    }
  `}
`;

export const ctaButtonWrapper = css`
  margin: ${stack(spacing.xl)};
  text-align: center;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: ${stack(spacing.xxxxl)};
    `,
  )}
`;

export const buttonCheckmarkIcon = css`
  display: inline-block;
  margin: -2px 5px 0 0;
  width: 18px;
  height: 18px;
`;

export const faqsContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 80%;
  margin: ${pxToRem(spacing.xxxl)} auto 0;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      max-width: 40%;
    `,
  )}
`;

export const questionsSectionTitle = css`
  align-self: center;
  margin-bottom: ${pxToRem(spacing.xxxl)};
`;

export const questionsContainer = css`
  margin-bottom: ${pxToRem(spacing.xxl)};
`;

export const linkText = css`
  text-decoration: none;
  cursor: pointer;
`;

export const answers = css`
  margin: 0;
`;

export const tcsContent = css`
  display: flex;
  justify-content: left;
  align-item: left;
  margin: 0 auto;
  border-radius: 10px;
  padding: ${pxToRem(spacing.sm)};
  color: #1e1e29;

  p {
    margin: 0;
    padding-left: ${pxToRem(spacing.xxl)};
    background-image: url(${descriptionIcon});
    background-position: 0 50%;
    background-repeat: no-repeat;
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    font-size: ${pxToRem(text.BODY.XS.fontSize)};
    line-height: 1.71;
  }

  button {
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
    color: #1e1e29;
    border: none;
    background: none;
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    font-size: ${pxToRem(text.BODY.XS.fontSize)};
  }
`;

export const tcsContainer = css`
  padding-left: ${pxToRem(spacing.xl)};
  padding-right: ${pxToRem(spacing.xl)};
  margin: 0 auto;
  max-width: 1500px;
`;

export const tcsModalBodyWrapper = css`
  padding: ${pxToRem(spacing.xl)};

  h6 {
    margin: ${pxToRem(spacing.xs)} 0;
  }

  p {
    margin: 0;
  }
`;

export const tcsModalheading = css`
  margin: 0;
  padding-left: ${pxToRem(spacing.md)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-size: ${pxToRem(text.BODY.MD.fontSize)};
`;

export const tcsModalbody = css`
  padding-top: 1rem;

  div {
    display: block;

    h6 {
      margin: 2rem 0 0.5rem;
      padding: 0;
    }

    p {
      margin-top: 0;
    }

    li {
      margin-bottom: 0.5rem;
      line-height: 1.75rem;
    }
  }
`;
